var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ComboboxInput',{staticClass:"fit-height g",attrs:{"listStyle":"max-height:300px","labal":"","labelKey":_vm.label,"labelStart":_vm.label,"items":_vm.volumes},on:{"input":_vm.showBook}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }